import { render, staticRenderFns } from "./LocalEditar.vue?vue&type=template&id=e8f7258c&scoped=true&"
import script from "./LocalEditar.vue?vue&type=script&lang=js&"
export * from "./LocalEditar.vue?vue&type=script&lang=js&"
import style0 from "./LocalEditar.vue?vue&type=style&index=0&id=e8f7258c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f7258c",
  null
  
)

export default component.exports